import React, { useState, useEffect } from 'react';
import AvatarInfoBanner from './AvatarInfoBanner';

const AvatarWrapper = () => {
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const avatarEl = document.querySelector('eyeai-avatar-component');
    if (!avatarEl) return;

    const seen = localStorage.getItem('avatarInfoSeen');
    if (seen) return;

    // Show info banner on first interaction with the avatar (non-blocking)
    const handleFirstClick = () => {
      const alreadySeen = localStorage.getItem('avatarInfoSeen');
      if (!alreadySeen) {
        setShowInfo(true);
      }
    };

    avatarEl.addEventListener('click', handleFirstClick, true);

    return () => {
      avatarEl.removeEventListener('click', handleFirstClick, true);
    };
  }, []);

  // Pause/resume hero video when avatar component opens/closes
  useEffect(() => {
    const avatarEl = document.querySelector('eyeai-avatar-component');
    if (!avatarEl) return;

    let videoWasPlaying = false;
    let wasOpen = false;

    const checkAvatarState = () => {
      const heroVideo = document.getElementById('hero-video');
      if (!heroVideo) return;

      // Detect open state: check shadow DOM for expanded interface or modal
      let isOpen = false;
      const shadowRoot = avatarEl.shadowRoot;
      if (shadowRoot) {
        const modal = shadowRoot.querySelector('.modal, [class*="modal"], [class*="interface"]:not([class*="collapsed"])');
        const expanded = shadowRoot.querySelector('[class*="expanded"], [class*="active-session"], [class*="show-avatar"]');
        isOpen = !!(modal || expanded);
      }

      // Fallback: check host element attributes/classes
      if (!isOpen) {
        isOpen = avatarEl.hasAttribute('expanded') ||
          avatarEl.hasAttribute('open') ||
          avatarEl.classList.contains('expanded') ||
          avatarEl.classList.contains('open');
      }

      if (isOpen && !wasOpen) {
        videoWasPlaying = !heroVideo.paused;
        if (!heroVideo.paused) {
          heroVideo.pause();
        }
      } else if (!isOpen && wasOpen && videoWasPlaying) {
        heroVideo.play().catch(() => {});
        videoWasPlaying = false;
      }

      wasOpen = isOpen;
    };

    // Observe the host element
    const hostObserver = new MutationObserver(checkAvatarState);
    hostObserver.observe(avatarEl, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    // Observe shadow DOM if accessible
    if (avatarEl.shadowRoot) {
      const shadowObserver = new MutationObserver(checkAvatarState);
      shadowObserver.observe(avatarEl.shadowRoot, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      return () => {
        hostObserver.disconnect();
        shadowObserver.disconnect();
      };
    }

    return () => hostObserver.disconnect();
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('avatarInfoSeen', 'true');
    setShowInfo(false);
  };

  if (!showInfo) return null;

  return <AvatarInfoBanner onDismiss={handleDismiss} />;
};

export default AvatarWrapper;
